import type { GetApiV1AddressBookMyParams } from '@1webit/cvs-api-scheme/models';
import { queryOptions } from '@tanstack/react-query';

import { DEFAULT_TABLE_PAGE_SIZE } from '@/constants';
import type { BaseTableParams } from '@/utils';
import { getResponse, paginationToApiFormat, queryParams } from '@/utils';

export const getApiV1AddressBook = (page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => {
  return queryOptions({
    queryKey: ['getApiV1AddressBook', page, limit, sort],
    queryFn: () => getResponse('getApiV1AddressBook', queryParams({
      sort,
      limit,
      offset: (page - 1) * limit,
    })),
  });
};

export const getApiV1AddressBookMy = (params: BaseTableParams<GetApiV1AddressBookMyParams>) => queryOptions({
  queryKey: ['getApiV1AddressBookMy', params],
  queryFn: () => getResponse('getApiV1AddressBookMy', paginationToApiFormat(params)),
});

// detail
export const getApiV1AddressBookAddressBookId = (id: number) => {
  return queryOptions({
    queryKey: ['getApiV1AddressBookAddressBookId', id],
    queryFn: () => getResponse('getApiV1AddressBookAddressBookId', id),
  });
};
export const getApiV1AddressBookAddressBookIdContact = (id: number, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => {
  return queryOptions({
    queryKey: ['getApiV1AddressBookAddressBookIdContact', id, page, limit, sort],
    queryFn: () => getResponse('getApiV1AddressBookAddressBookIdContact', id, queryParams({
      offset: (page - 1) * limit,
      limit,
      sort,
    })),
  });
};

export const getApiV1AddressBookList = () => {
  return queryOptions({
    queryKey: ['getApiV1AddressBookList'],
    queryFn: () => getResponse('getApiV1AddressBookList'),
  });
};

export const getApiV1AddressBookUserRights = (id: number) => queryOptions({
  queryKey: ['getApiV1AddressBookUserRights', id],
  queryFn: () => getResponse('getApiV1AddressBookUserRights', { addressBookId: id }),
});
